import { render } from "./CheckInfo.vue?vue&type=template&id=6bb3dedd"
import script from "./CheckInfo.vue?vue&type=script&lang=js"
export * from "./CheckInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LENOVO\\Desktop\\Septem\\mobins.frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__